import { OUTER_CONTAINER_CLASSES, INNER_CONTAINER_CLASSES } from '../consts';
import Filters from './Filters';
import Header from './Header';
import Orders from './Orders';

function Container() {
  return (
    <div className="text-onsurface-900 grow pt-[56px] md:pt-[60px] flex flex-col h-full max-h-full overflow-auto scrollbar items-center bg-palette-sbiu-grey">
      <div className={`${OUTER_CONTAINER_CLASSES} justify-center py-3 bg-white border-b border-palette-color-bg-grey`}>
        <div className={`${INNER_CONTAINER_CLASSES} items-center`}>
          <Filters />
        </div>
      </div>
      <div className={`${OUTER_CONTAINER_CLASSES} justify-center py-3`}>
        <div className={`${INNER_CONTAINER_CLASSES} items-center`}>
          <Header />
        </div>
      </div>
      <div
        className={`${OUTER_CONTAINER_CLASSES} py-4 md:py-8 flex-col justify-start grow bg-palette-sbiu-grey border-t border-palette-color-bg-grey`}
      >
        <div className={`${INNER_CONTAINER_CLASSES}`}>
          <Orders />
        </div>
      </div>
    </div>
  );
}

export default Container;
